import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AlertController, ModalController, ToastController } from '@ionic/angular/standalone';
//import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { ActivitiesResponse, Activity, BasicResponse, BookingResponse, BrandsResponse, CategoriesResponse, CheckVerifyCodeResponse, ClientInfoResponse, ConversationResponse, CreateVerifyCodeResponse, EmailCredentials, Group, GroupField, GroupPrivacyConsentResponse, GroupPrivacyConsentUser, GroupPrivacyConsentUserResponse, GroupPrivacyResponse, GroupResponse, GroupsResponse, InsertInviteResponse, InviteCodeResponse, LocalData, LocalDataResponse, NeedsUpdateResponse, NewsResponse, NotificationsResponse, PlacesResponse, RankingResponse, RssFeedResponse, SearchResponse, Service, ServiceResponse, ServicesResponse, ShippingData, ShippingDataResponse, SimpleUserResponse, StatsResponse, Training, TrainingQuestResponse, TrainingResponse, TrainingResult, Transaction, UserBookingTransactionResponse, UserQuestResponse, VerifyTrainingResponse, WalletResponse } from './app.types';
import { MissingNameComponent } from './components/missing-name/missing-name.component';
import { Preferences } from '@capacitor/preferences';

import { v4 as uuidv4 } from 'uuid';

//import { FCM } from "@capacitor-community/fcm";
//import { PushNotifications } from "@capacitor/push-notifications";
import { firstValueFrom, Subject, Subscription } from 'rxjs';

import { format, addSeconds, parseISO, isSameDay, formatDistanceToNow, setDefaultOptions } from 'date-fns';
import { it } from 'date-fns/locale';

import { SearchFNOMCEOResponse, UserPrivacy } from './auth-form/auth-form.page';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AuthService, TempoUser } from './auth.service';
import { Device } from '@capacitor/device';
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { environment } from 'src/environments/environment';

setDefaultOptions({ locale: it })

export const firebaseConfig = {
    projectId: 'tempo-85b92',
    appId: '1:1042899946632:web:f4dcf1f994ea0abf52233d',
    storageBucket: 'tempo-85b92.appspot.com',
    apiKey: 'AIzaSyDaybaAq2k8MhXKdGVWg-5ViziZrUhXZGg',
    authDomain: 'tempo-85b92.firebaseapp.com',
    messagingSenderId: '1042899946632',
    measurementId: 'G-Y4CJPLT2GB',
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {





    private auth = inject(AuthService)

    user: TempoUser
    tempUid: string
    //mainCategory: Category
    //mainGroup: Group
    //allCategories: Category[]
    //flatCategories: Category[]
    //platform: string

    endpoint = "https://api.aitempo.online"
    httpOptions = {
        headers: new HttpHeaders({
            'Authorization': 'Bearer 629ddb523040fcafa3abf9f4f99fb216'
        })
    };

    public navState = new Subject()
    //public authListener = new Subject()

    authSub: Subscription


    constructor(
        private modalController: ModalController,
        private http: HttpClient,
        private toastController: ToastController,
        private alertController: AlertController
    ) {

        if (!Capacitor.isNativePlatform()) {
            Device.getId().then((d) => {
                console.log("Device ID", d)
                this.tempUid = d.identifier
            })
        } else {
            //Preferences.remove({key: "tempUid"})
            Preferences.get({ key: "tempUid" }).then((res) => {
                if (res.value) {
                    this.tempUid = res.value
                } else {
                    this.tempUid = uuidv4()
                    Preferences.set({ key: "tempUid", value: this.tempUid })
                }
            })
        }


        this.authSub = this.auth.authStateChange$.subscribe((u) => {
            this.user = u

            // Preferences.remove({ key: this.user.uid + "_current_activity" })
            // Preferences.remove({ key: "activities" })
            // console.log("Removed activities")
        })

        // if (Capacitor.getPlatform() == "web") {
        //     console.log("Running on web")
        //     initializeApp(firebase)
        // }

        //initializeApp(firebase)

        // FirebaseAuthentication.addListener("idTokenChange", async (change) => {
        //     if(change.token) {
        //         console.log("### idTokenChange")
        //     }
        // })



    }

    async initApi() {

        console.log("Initialize API...")
    }


    async getMyIpData() {

        const res = await firstValueFrom(this.http.get<any>("https://api.ipify.org?format=json"))
        console.log("my ip", res.ip)

        const url = `http://ip-api.com/json/${res.ip}`
        const data = await firstValueFrom(this.http.get<any>(url))

        return {
            ip: data.query,
            country: data.country,
            city: data.city,
            latitude: data.lat,
            longitude: data.lon,
            timezone: data.timezone,
            isp: data.isp
        }

    }

    async setCurrentActivity(a: Activity) {
        await Preferences.set({
            key: this.user.uid + "_current_activity",
            value: JSON.stringify(a)
        })
    }

    async getCurrentActivity() {
        //await Preferences.remove({ key: this.user.uid + "_current_activity" })
        if (!this.user) {
            console.log("No user in getCurrentActivity")
            return null
        }
        const res = await Preferences.get({ key: this.user.uid + "_current_activity" })
        if (res.value) {
            const a = JSON.parse(res.value) as Activity
            return a
        }
        return null
    }

    async stopCurrentActivity(a: Activity) {
        await Preferences.remove({ key: this.user.uid + "_current_activity" })
    }

    async getActivities() {
        //await Preferences.remove({ key: "activities" })
        const url = "https://api.aitempo.online/getActivities"

        const body = {
            uid: this.user.uid,
            gid: this.user.selectedGroup.gid
        }

        const res = await firstValueFrom(this.http.post<ActivitiesResponse>(url, body, this.httpOptions))

        return res.activities
        // const res = await Preferences.get({ key: "activities" })
        // if (res.value) {
        //     return JSON.parse(res.value) as Activity[]
        // }
        // return []
    }

    async addActivity(a: Activity) {

        const url = "https://api.aitempo.online/addActivity"
        return firstValueFrom(this.http.post<BasicResponse>(url, a, this.httpOptions))



        // const res = await Preferences.get({ key: "activities" })
        // if (res.value) {

        //     const all = JSON.parse(res.value) as Activity[]
        //     a.aid = all.length + 1
        //     all.push(a)
        //     await Preferences.set({
        //         key: "activities",
        //         value: JSON.stringify(all)
        //     })
        // } else {
        //     await Preferences.set({
        //         key: "activities",
        //         value: JSON.stringify([a])
        //     })
        // }
    }

    // async checkUserRedeem(user: User) {
    //     const rres = await this.checkRedeem()
    //     console.log(`Found ${rres.results.length} redeems`)
    //     for (let red of rres.results) {

    //         let showModal = false
    //         const udres = await this.getUserGroupData(user.uid, red.data.gid)

    //         if(udres.result) {
    //             console.log("user group data", udres.result.data)
    //             for (const ugf of udres.result.data.groupFields) {
    //                 if (!ugf.valid && ugf.required) {
    //                     showModal = true
    //                     break
    //                 }
    //             }
    //         } else {
    //             showModal = true
    //         }


    //         const upr = await this.getUserPrivacy(user.uid)
    //         if (!upr.result) {
    //             console.log("No privacy record in auth state changed")
    //             showModal = true
    //         }



    //         let inviteDiscarded = false
    //         const rgroup = await this.groupById(red.data.gid)

    //         if (showModal) {

    //             const gfres = await this.getGroupFields(rgroup.group.gid)


    //             const rmodal = await this.modalController.create({
    //                 component: AuthFormPage,
    //                 componentProps: {
    //                     groupFields: gfres.groupFields,
    //                     group: rgroup.group,
    //                     firebaseUid: user.uid,
    //                     redeem: red.data
    //                 }
    //             })
    //             rmodal.present()
    //             const { data } = await rmodal.onDidDismiss()
    //             if (!data) {
    //                 this.showLoginModal()
    //                 return
    //             } else {
    //                 inviteDiscarded = data.inviteDiscarded
    //             }
    //         } else {
    //             console.log("no need to show modal")
    //         }


    //         if (!inviteDiscarded) {
    //             // TODO
    //             // await this.transferAsset(this.algoUser.address, red.data.amount, "Riscatto credito di formazione", rgroup.group.address)
    //             //await this.invalidateRedeem(red.data.code, red.data.gid, user.uid, red.score)
    //             this.showToast(`Hai guadagnato ${red.data.amount} CT`, "checkmark")
    //             this.selectedGroup = rgroup.group
    //             this.selectedGroupChanged.next(rgroup.group)
    //         }

    //     }
    // }

    currency(num: number | string) {

        if (typeof num == "string") {
            num = parseFloat(num)
        }

        return num.toLocaleString("it-IT", {
            currency: "EUR",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        })
    }

    async getWallet() {
        // if (!this.user) {
        //     const ur = await FirebaseAuthentication.getCurrentUser()
        //     await this.setupUser(ur.user)
        // }
        const url = "https://api.aitempo.online/wallet/" + this.user.uid + "/" + this.user.selectedGroup.gid
        return firstValueFrom(this.http.get<WalletResponse>(url, this.httpOptions))
    }

    async getUser(uid: string) {
        const url = "https://api.aitempo.online/getUser/" + uid

        return firstValueFrom(this.http.get<SimpleUserResponse>(url, this.httpOptions))
    }
    async sendCompanyEmail(t: Training) {



        const url = "https://api.aitempo.online/sendCompanyEmail"
        //const udatares = await this.auth.getUserGroupData(this.user.uid, t.gid)
        const body = {
            uid: this.user.uid,
            tid: t.tid,
            title: t.title,
            company_training_email: t.company_training_email,
            user_email: this.user.email,
            //user_data:  udatares.result
        }

        return firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async sendCompanyApiCall(t: Training) {

        const body = {
            uid: this.user.uid,
            tid: t.tid,
            title: t.title,
            company_training_email: t.company_training_email,
            user_email: this.user.email
        }

        return firstValueFrom(this.http.post(t.company_training_api, body, this.httpOptions))
    }

    // async getWalletBalance() {
    //     let info = await this.getAlgoAccountInfo()
    //     var balance = 0
    //     for (let a of info.assets) {
    //         if (a["asset-id"] == environment.ASSETID) {
    //             balance = a.amount
    //         }
    //     }
    //     return balance + ""
    // }

    // TODO upgrade to pt transaction

    // async transaction(address: string, amount: number) {
    //     var url = this.endpoint + "/transaction"

    //     let body = {
    //         receiver: address,
    //         sender: environment.CREATOR_ADDRESS,
    //         amount: amount,
    //         note: "Tempo Account initializazion"
    //     }

    //     console.log("calling: " + url)
    //     let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
    //             if (data.response) {
    //                 resolve(data)
    //             } else {
    //                 reject(data.message)
    //             }
    //         })
    //     })

    //     return p
    // }







    // TODO upgrade to pt transfer
    // async transferAsset(recipient: string, amount: number, note: string, sender: string) {
    //     var url = "https://api.aitempo.online/transferAsset"

    //     let body = {
    //         sender: sender,
    //         recipient: recipient,
    //         note: note,
    //         amount: amount,
    //         assetID: environment.ASSETID
    //     }

    //     console.log("calling: " + url)
    //     let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
    //             if (data) {
    //                 resolve(data)
    //             } else {
    //                 reject(data)
    //             }
    //         })
    //     })

    //     return p
    // }

    async insertInviteCode(gid: number) {
        var url = "https://api.aitempo.online/insertInviteCode"

        let body = {
            gid: gid,
            firebaseUid: this.user.uid,
            fromAdmin: false
        }

        console.log("calling: " + url)
        let p: Promise<InsertInviteResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: InsertInviteResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }


    // async sendPasswordResetEmail(email: string) {
    //     var url = "https://api.aitempo.online/sendPasswordResetEmail"

    //     const data = {
    //         email: email
    //     }

    //     console.log("calling: " + url)
    //     let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, data, this.httpOptions).toPromise().then((data: BasicResponse) => {
    //             if (data) {
    //                 resolve(data)
    //             } else {
    //                 reject(data)
    //             }
    //         })
    //     })

    //     return p
    // }

    async resetPasswordFromEmail(email: string, password: string) {
        var url = "https://api.aitempo.online/resetPasswordFromEmail"

        const data = {
            email: email,
            password: password
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, data, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async sendVerificationEmail(uid: string, email: string) {
        var url = "https://api.aitempo.online/sendVerificationEmail"

        const data = {
            uid: uid,
            email: email
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, data, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async createVerifyCode(uid: string) {
        var url = "https://api.aitempo.online/createVerifyCode"

        const data = {
            uid: uid
        }
        console.log("calling: " + url)
        let p: Promise<CreateVerifyCodeResponse> = new Promise((resolve, reject) => {
            this.http.post(url, data, this.httpOptions).toPromise().then((data: CreateVerifyCodeResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async checkVerifyCode(code: string) {
        var url = "https://api.aitempo.online/checkVerifyCode/" + code

        console.log("calling: " + url)
        let p: Promise<CheckVerifyCodeResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: CheckVerifyCodeResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }



    async checkInviteCode(code: string) {
        const u = await FirebaseAuthentication.getCurrentUser()
        var url = "https://api.aitempo.online/checkInviteCode/" + code + "/" + u.user.uid

        console.log("calling: " + url)
        let p: Promise<InviteCodeResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: InviteCodeResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async showTutorial() {
        try {
            const au = await this.getSecureObject("tutorial")

        } catch (error) {
            console.log("NO ALGO USER:", error.message)
        }
    }

    async enableNotifications() {

        if (Capacitor.getPlatform() === "web") return

        // let permStatus = await PushNotifications.checkPermissions()

        // if (permStatus.receive === "prompt") {
        //     permStatus = await PushNotifications.requestPermissions()
        // }

        // if (permStatus.receive !== "granted") {
        //     throw new Error("User denied permissions!")
        // }

        // PushNotifications.addListener("registration", async (token) => {
        //     console.info("Registration token: ", token.value);

        //     await FCM.subscribeTo({ topic: "user_" + this.user.uid })
        //     console.log("Subscribed to topic user_" + this.user.uid)

        //     for (let g of this.unlockedGroups) {
        //         await FCM.subscribeTo({ topic: "group_" + g.gid })
        //         console.log("Subscribed to topic group_" + g.gid)
        //     }


        //     if (Capacitor.getPlatform() == "android") {
        //         PushNotifications.createChannel({
        //             id: "tnc",
        //             name: "Tempo Notification Channel",
        //             importance: 5
        //         })
        //     }
        // })

        // PushNotifications.addListener("registrationError", err => {
        //     console.error("Registration error: ", err.error);
        // })



        // PushNotifications.addListener("pushNotificationReceived", async (notification) => {
        //     console.log("Push notification received: ", notification.title);
        // })

        // PushNotifications.addListener("pushNotificationActionPerformed", async (data) => {
        //     console.log("Push notification action performed: ", data.notification.data.route);

        //     if (data.notification.data.route) {
        //         let r = data.notification.data.route
        //         if (r.includes("/service/")) {
        //             let sid = parseInt(r.split("/")[2])



        //             let res = await this.getAllServices()
        //             let nservice = res.services.filter((s) => { return s.sid == sid })[0]

        //             const modal = await this.modalController.create({
        //                 component: ServicePage,
        //                 componentProps: {
        //                     service: nservice
        //                 }
        //             })
        //             await modal.present()

        //         } else if (r.includes("/booking/")) {
        //             let bid = parseInt(r.split("/")[2])
        //             let res = await this.bookings()
        //             let nservice = res.services.filter((s) => { return s.bid == bid })[0]

        //             const modal = await this.modalController.create({
        //                 component: BookingDetailPage,
        //                 componentProps: {
        //                     booking: nservice
        //                 }
        //             })
        //             await modal.present()
        //             await modal.onDidDismiss()

        //             // TODO auth listener app link
        //             this.nav.navigateForward("/booking")
        //         } else if (r.includes("/chat/")) {
        //             let ruid = r.split("/")[2]

        //             const modal = await this.modalController.create({
        //                 component: ChatPage,
        //                 componentProps: {
        //                     openChatWithUid: ruid
        //                 }
        //             })
        //             await modal.present()
        //         } else if (r.includes("/news/")) {
        //             let nfid = r.split("/")[2]

        //             const res = await this.getNews(null)
        //             let n = res.news.filter((gn) => {
        //                 return gn.nfid == nfid
        //             })[0]

        //             if (n.gid != this.selectedGroup.gid) {
        //                 let ng = this.unlockedGroups.filter((g) => {
        //                     return g.gid == n.gid
        //                 })

        //                 if (ng.length > 0) {
        //                     this.selectedGroup = ng[0]
        //                     this.mainGroup = ng[0]
        //                     this.selectedGroupChanged.next(null)
        //                     this.saveSelectedGroup()

        //                 }
        //             }

        //             const modal = await this.modalController.create({
        //                 component: FeedItemComponent,
        //                 componentProps: {
        //                     item: n,
        //                     creator: this.mainGroup.name ?? "News",
        //                     image: this.mainGroup.image ?? "https://admin.aitempo.online/assets/icon/logo-tempo-icon.png"
        //                 }
        //             })

        //             await modal.present()
        //         } else {
        //             this.router.navigate([data.notification.data.route])
        //         }
        //     }
        // })


        // await PushNotifications.register()

    }

    async setEmailLogin(value: string) {
        await Preferences.set({
            key: "emailLogin",
            value: value
        })

    }

    async getEmailLogin() {
        const res = await Preferences.get({
            key: "emailLogin"
        })
        if (res.value) {
            return res.value
        } else {
            return "false"
        }

    }




    getTimestampId() {
        const timestamp = Date.now()
        const hexString = timestamp.toString(36)
        return hexString
    }

    async setTrainingStatus(tr: TrainingResult, t: Training) {
        await Preferences.set({
            key: t.tid + "",
            value: JSON.stringify(tr)
        })
    }

    async getTrainingStatus(tid: number): Promise<TrainingResult> {

        //if (!environment.production) return null

        const res = await Preferences.get({
            key: tid + ""
        })

        if (res.value) {
            let tr: TrainingResult = JSON.parse(res.value)
            return tr
        } else {
            return null
        }

    }

    async getTrainingCurrentTime(tid: number) {
        const res = await Preferences.get({
            key: "ct_" + tid
        })
        if (res.value) {
            return Number(res.value)
        }
        return 0
    }

    async setTrainingCurrentTime(tid: number, currentTime: number) {
        const ct = await this.getTrainingCurrentTime(tid)
        if (currentTime > ct) {
            await Preferences.set({
                key: "ct_" + tid,
                value: currentTime + ""
            })
        }
    }

    async setRemember(remember: boolean) {
        await Preferences.set({
            key: "remember",
            value: JSON.stringify(remember)
        })
    }

    async getRemember() {
        const res = await Preferences.get({
            key: "remember"
        })
        if (res.value) {
            return JSON.parse(res.value)
        }
        return null
    }

    async removeRemember() {
        await Preferences.remove({
            key: "remember"
        })
    }

    async setEmailCredentials(email: string, password: string) {
        let ec: EmailCredentials = {
            email: email,
            pass: password
        }

        await Preferences.set({
            key: "emailCredentials",
            value: JSON.stringify(ec)
        })
    }

    async getEmailCredentials() {
        const res = await Preferences.get({
            key: "emailCredentials"
        })
        if (res.value) {
            let ec: EmailCredentials = JSON.parse(res.value)
            return ec
        }
        return null

    }

    async removeEmailCredentials() {
        await Preferences.remove({
            key: "emailCredentials"
        })
    }

    async getSecureObject(key: string) {
        const so = await Preferences.get({
            key: key
        })

        if (so.value) {
            return JSON.parse(so.value)
        }
        return null
    }

    async removeSecureObject(key: string) {
        await Preferences.remove({
            key: key
        })
    }



    // async showLoginModal() {
    //     console.log("showLoginModal", this.router.url)
    //     const modal = await this.modalController.create({
    //         component: AuthNavPage,
    //         backdropDismiss: false
    //     });
    //     await modal.present()
    // }

    async showMissingNameModal() {
        const modal = await this.modalController.create({
            component: MissingNameComponent,
            initialBreakpoint: 0.4,
            breakpoints: [0.4]
        });
        await modal.present()
        const { data } = await modal.onWillDismiss()
        if (data.userName) {
            await FirebaseAuthentication.updateProfile({
                displayName: data.userName
            })
            // await updateCurrentUser(this.auth, this.auth.currentUser)
            // await this.auth.currentUser.getIdToken(true)
            //this.user = this.auth.currentUser
        }
    }




    /*
    async showCategorySelection(user: User) {
      const modal = await this.modalController.create({
        component: CategorySelectComponent
      });
      await modal.present()
      const { data } = await modal.onWillDismiss()
      if (data.category) {
        this.mainCategory = data.category
  
        await this.addUser(this.mainCategory.cid, user.uid, user.displayName, user.photoURL)
  
        if (!this.algoUser) {
          this.generateAccount(user)
        } else {
          await this.updateUser(user.uid, user.displayName, user.photoURL)
          this.user = user
          this.enableNotifications()
        }
  
  
      }
    }
    */

    // async generateAccount(user: User) {
    //     const algoAccount = generateAccount()

    //     this.algoUser = {
    //         address: algoAccount.addr,
    //         mnemonic: secretKeyToMnemonic(algoAccount.sk)
    //     }

    //     let ainfo = await this.getAlgoAccountInfo()
    //     let balance = ainfo["amount"]
    //     let min = ainfo["min-balance"] // minimum balance to found

    //     console.log("balance: " + balance + " min: " + min)

    //     if (balance < min) {
    //         let amount = (min - balance) * 2 + 1000
    //         console.log("amount to found: ", amount)

    //         try {
    //             await this.transaction(this.algoUser.address, amount)
    //         } catch (error) {
    //             console.log("transaction error: " + error.message)
    //             return false
    //         }

    //     }

    //     await this.optIn()

    //     await this.setSecureObject(user.uid, this.algoUser)
    //     /*
    //     await this.updateUser(user.uid, user.displayName, user.photoURL, user.emailVerified)
    //     this.user = user
    //     this.enableNotifications()
    //     */

    //     return true
    // }


    async showToast(message: string, icon: string) {
        const toast = await this.toastController.create({
            duration: 3500,
            message: message,
            icon: icon,
            position: "bottom"
        })
        toast.present()
    }

    convertFeedData(date: string) {
        return format(new Date(date), 'd MMMM yyyy - HH:mm')

    }

    readableDate(date: string) {
        return format(new Date(date), 'd MMMM yyyy - HH:mm')
    }

    readableDateNoTime(date: string) {
        return format(new Date(date), 'd MMMM yyyy')
    }

    readableMinSec(time: number) {
        const roundedTime = Math.round(time);
        const date = addSeconds(new Date(0), roundedTime);
        return format(date, 'mm:ss');
    }

    relativeDateTime(date: string) {
        const parsedDate = parseISO(date);
        if (isSameDay(parsedDate, new Date())) {
            return format(parsedDate, 'HH:mm');
        } else {
            return format(parsedDate, 'd MMMM yyyy - HH:mm');
        }
    }

    relativeDate(date: string) {
        const parsedDate = parseISO(date);
        return formatDistanceToNow(parsedDate, { addSuffix: true }).replace("circa ", "");
    }

    timerDisplay(seconds: number) {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const secs = seconds % 60

        // Format as HH:mm:ss
        return [
            hours.toString().padStart(2, '0'),
            minutes.toString().padStart(2, '0'),
            secs.toString().padStart(2, '0'),
        ].join(':')
    }

    getDistance(latitude: number, longitude: number, latitude1: number, longitude1: number) {
        const R = 6371e3; // metres
        const φ1 = latitude * Math.PI / 180; // φ in radians
        const φ2 = latitude1 * Math.PI / 180; // φ in radians
        const Δφ = (latitude1 - latitude) * Math.PI / 180; // in radians
        const Δλ = (longitude1 - longitude) * Math.PI / 180; // in radians

        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c; // in metres
    }


    /*
    * API METHODS
    */

    async clientInfo() {
        const url = "https://api.aitempo.online/clientInfo"
        console.log("calling: " + url)
        let p: Promise<ClientInfoResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ClientInfoResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })
        return p
    }



    async getMyIp() {

        const res = await firstValueFrom(this.http.get<any>("https://api.ipify.org?format=json"))
        console.log("my ip", res.ip)

        return res.ip

    }



    async ptTransaction(ptt: Transaction) {
        const url = "https://api.aitempo.online/ptTransaction"
        return await firstValueFrom(this.http.post<BasicResponse>(url, ptt, this.httpOptions))
    }


    async ptBookingTransaction(ptt: Transaction) {
        const url = "https://api.aitempo.online/ptBookingTransaction"
        return await firstValueFrom(this.http.post<BasicResponse>(url, ptt, this.httpOptions))
    }

    async saveTrainingUserData(uid: string, tid: number, responses: UserQuestResponse[]) {
        const url = "https://api.aitempo.online/saveTrainingUserData"
        const body = {
            uid: uid,
            tid: tid,
            responses: responses
        }
        return await firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async deleteUserGroupData(ugdid: number) {
        var url = "https://api.aitempo.online/deleteUserGroupData"

        const body = {
            ugdid: ugdid
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async setUserGroupData(firebaseUid: string, gid: number, groupFields: GroupField[]) {
        var url = "https://api.aitempo.online/setUserGroupData"

        const body = {
            firebaseUid: firebaseUid,
            gid: gid,
            data: {
                groupFields: groupFields
            }
        }

        return await firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async setUserServiceData(firebaseUid: string, gid: number, groupFields: GroupField[]) {
        var url = "https://api.aitempo.online/setUserServiceData"

        const body = {
            firebaseUid: firebaseUid,
            gid: gid,
            data: {
                groupFields: groupFields
            }
        }

        return await firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async setUserServiceDataCustom(firebaseUid: string, sid: number, groupFields: GroupField[]) {
        var url = "https://api.aitempo.online/setUserServiceDataCustom"

        const body = {
            firebaseUid: firebaseUid,
            sid: sid,
            data: {
                groupFields: groupFields
            }
        }

        console.log()

        return await firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }



    async searchFNOMCEO(nome: string, cognome: string, data: string) {
        var url = "https://api.aitempo.online/searchFNOMCEO"

        const body = {
            nome: nome,
            cognome: cognome,
            data: data
        }

        console.log(body)

        console.log("calling: " + url)
        let p: Promise<SearchFNOMCEOResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: SearchFNOMCEOResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getGroupPrivacy(gid: number) {
        const url = "https://api.aitempo.online/getGroupPrivacy/" + gid
        return firstValueFrom(this.http.get<GroupPrivacyResponse>(url, this.httpOptions))
    }

    async getGroupPrivacyConsent(gid: number) {
        const url = "https://api.aitempo.online/getGroupPrivacyConsent/" + gid
        return firstValueFrom(this.http.get<GroupPrivacyConsentResponse>(url, this.httpOptions))
    }

    async getGroupPrivacyConsentUser(firebaseUid: string, gid: number) {
        const url = "https://api.aitempo.online/getGroupPrivacyConsentUser/" + firebaseUid + "/" + gid
        return firstValueFrom(this.http.get<GroupPrivacyConsentUserResponse>(url, this.httpOptions))
    }

    async setGroupPrivacyConsentUser(gpcu: GroupPrivacyConsentUser) {
        const url = "https://api.aitempo.online/setGroupPrivacyConsentUser"
        return firstValueFrom(this.http.post<BasicResponse>(url, gpcu, this.httpOptions))
    }

    async updateUserPrivacy(up: UserPrivacy) {
        var url = "https://api.aitempo.online/updateUserPrivacy"
        return firstValueFrom(this.http.post<BasicResponse>(url, up, this.httpOptions))
    }

    async groupById(gid: number) {
        var url = "https://api.aitempo.online/groupById/" + gid


        console.log("calling: " + url)
        let p: Promise<GroupResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: GroupResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }



    async groupsByUnlock(uid: string) {
        var url = "https://api.aitempo.online/groupsByUnlock/" + uid


        console.log("calling: " + url)
        let p: Promise<GroupsResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: GroupsResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getRssFeed(url: string): Promise<RssFeedResponse> {
        var url = "https://api.aitempo.online/rssFeed?url=" + url


        let p: Promise<RssFeedResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: RssFeedResponse) => {
                if (data.response) {
                    resolve(data)
                } else {
                    reject(data.message)
                }
            })
        })

        return p
    }


    async deleteBooking(bid: number) {
        var url = "https://api.aitempo.online/deleteBooking/" + bid

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getLocalData(tid: number, uid: string) {
        const url = "https://api.aitempo.online/getLocalData"
        const body = {
            tid: tid,
            uid: uid
        }
        return firstValueFrom(this.http.post<LocalDataResponse>(url, body, this.httpOptions))
    }

    async saveLocalData(tid: number, uid: string, ld: LocalData) {
        const url = "https://api.aitempo.online/saveLocalData"
        const body = {
            tid: tid,
            uid: uid,
            ld: ld
        }
        return firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async getServiceById(sid: number) {
        const url = "https://api.aitempo.online/servicesbyid/" + sid
        return firstValueFrom(this.http.get<ServiceResponse>(url, this.httpOptions))
    }

    async getServices(gid: number) {
        var url = "https://api.aitempo.online/services/" + (gid ? gid : this.user.selectedGroup.gid)


        console.log("calling: " + url)
        let p: Promise<ServicesResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ServicesResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getAllServices() {
        var url = "https://api.aitempo.online/services/"


        console.log("calling: " + url)
        let p: Promise<ServicesResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ServicesResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getNews(gid: number) {
        var url = "https://api.aitempo.online/news/" + (gid ? gid : this.user.selectedGroup.gid)


        console.log("calling: " + url)
        let p: Promise<NewsResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: NewsResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getCategories() {
        var url = "https://api.aitempo.online/categories"

        console.log("calling: " + url)
        let p: Promise<CategoriesResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: CategoriesResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }



    async invalidateRedeem(code: string, gid: number, uid: string, score: number) {
        var url = "https://api.aitempo.online/invalidateRedeem"

        let body = {
            code: code,
            gid: gid,
            uid: uid,
            score: score
        }

        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data.response) {
                    resolve(data)
                } else {
                    console.log("invalidateRedeem error...", data)
                    reject(data)
                }
            })
        })

        return p
    }

    // async checkRedeem() {
    //     var url = "https://api.aitempo.online/checkRedeem"


    //     let body = {
    //         client_ip: this.client_ip,
    //         user_agent: this.user_agent
    //     }

    //     let p: Promise<CheckRedeemResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, body, this.httpOptions).toPromise().then((data: CheckRedeemResponse) => {
    //             if (data.response) {
    //                 resolve(data)
    //             } else {
    //                 console.log("checkRedeem error...", data)
    //                 reject(data)
    //             }
    //         })
    //     })

    //     return p
    // }

    // async redeem(code: string) {
    //     var url = "https://api.aitempo.online/redeem"


    //     let body = {
    //         code: code,
    //         uid: this.user.uid
    //     }

    //     let p: Promise<RedeemResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, body, this.httpOptions).toPromise().then((data: RedeemResponse) => {
    //             if (data.response) {
    //                 resolve(data)
    //             } else {
    //                 console.log("redeem error...", data)
    //                 reject(data)
    //             }
    //         })
    //     })

    //     return p
    // }


    async getRanking(uid: string, gid: number) {
        const url = "https://api.aitempo.online/ranking"
        const body = {
            uid: uid,
            gid: gid
        }
        return firstValueFrom(this.http.post<RankingResponse>(url, body, this.httpOptions))
    }


    async getUserStats(firebaseUid: string) {
        var url = "https://api.aitempo.online/getUserStats/" + firebaseUid + "/" + this.user.selectedGroup.gid

        console.log("calling: " + url)
        let p: Promise<StatsResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: StatsResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async updateUser(firebaseUid: string, displayName: string, photoURL: string, verified: boolean, gid: number) {
        var url = "https://api.aitempo.online/updateUser"

        let body = {
            firebaseUid: firebaseUid,
            gid: gid,
            displayName: displayName,
            photoURL: photoURL,
            verified: verified
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    async updateUserGroup(firebaseUid: string, gid: number) {
        var url = "https://api.aitempo.online/updateUserGroup"

        let body = {
            firebaseUid: firebaseUid,
            gid: gid
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }

    // async createRedeem(code: string, amount: number, tid: number, gid: number) {
    //     var url = "https://api.aitempo.online/createRedeem"

    //     let body = {
    //         code: code,
    //         amount: amount,
    //         tid: tid,
    //         gid: gid,
    //         client_ip: this.client_ip,
    //         user_agent: this.user_agent
    //     }

    //     console.log("calling: " + url)
    //     let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
    //         this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
    //             if (data) {
    //                 resolve(data)
    //             } else {
    //                 reject(data)
    //             }
    //         })
    //     })

    //     return p
    // }

    async createFingerprintGroupSubscribe(gid: string, fingerprint: string, uid?: string) {
        const url = "https://api.aitempo.online/createFingerprintGroupSubscribe"

        const body = {
            gid: gid,
            fingerprint: fingerprint,
            uid: uid
        }

        return firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }

    async createFingerprintToken(uid: string, source: string, fingerprint: string) {
        const url = "https://api.aitempo.online/createFingerprintToken"

        const body = {
            uid: uid,
            source: source,
            fingerprint: fingerprint
        }

        return firstValueFrom(this.http.post<BasicResponse>(url, body, this.httpOptions))
    }



    async getBrands() {
        const url = "https://api.aitempo.online/getBrands/" + this.user.selectedGroup.gid

        console.log("calling: " + url)
        return firstValueFrom(this.http.get<BrandsResponse>(url, this.httpOptions))
    }

    async getSingleTraining(tid: number) {
        var url = this.endpoint + "/training/" + tid


        console.log("calling: " + url)
        let p: Promise<TrainingResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: TrainingResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getInstagramPostData(url: string) {
        return firstValueFrom(this.http.post(this.endpoint + "/instagramPostMetadata", { url: url }, this.httpOptions)) as { html?: string, error?: any }
    }

    async getTrainings(gid: number, uid?: string) {
        var url = this.endpoint + "/trainings/" + (gid ? gid : this.user.selectedGroup.gid) + (uid ? "/" + uid : "")


        console.log("calling: " + url)
        return firstValueFrom(this.http.get<TrainingResponse>(url, this.httpOptions))
        
    }

    async getTrainingQuest(tid: number) {
        var url = this.endpoint + "/getTrainingQuest/" + tid


        console.log("calling: " + url)
        let p: Promise<TrainingQuestResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: TrainingQuestResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async verifyTraining(tid: number, respIds: string) {
        var url = this.endpoint + "/verifyTraining/" + tid + "?respIds=" + respIds


        console.log("calling: " + url)
        let p: Promise<VerifyTrainingResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: VerifyTrainingResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async bookService(sid: number, stype: string, shippingData: ShippingData) {
        const url = this.endpoint + "/bookService/" + this.user.uid + "/" + stype + "/" + sid

        return firstValueFrom(this.http.post<BookingResponse>(url, shippingData, this.httpOptions))

    }

    async getShippingData(bid: number) {
        var url = this.endpoint + "/shippingData/" + bid

        console.log("calling: " + url)
        let p: Promise<ShippingDataResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ShippingDataResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async bookings(uid?: string) {

        var url = this.endpoint + "/bookings/" + (uid ? uid : this.user.uid) + "/" + this.user.selectedGroup.gid


        console.log("calling: " + url)
        let p: Promise<ServicesResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ServicesResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getUserBookingTransaction(uid: string, sid: number) {
        const url = this.endpoint + "/getUserBookingTransaction"
        const body = {
            uid: uid,
            sid: sid
        }
        return firstValueFrom(this.http.post<UserBookingTransactionResponse>(url, body, this.httpOptions))
    }

    async getServiceBooking(uid: string, sid: number) {
        var url = this.endpoint + "/getServiceBooking/" + uid + "/" + sid


        console.log("calling: " + url)
        let p: Promise<ServiceResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ServiceResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async setBookingStatus(bid: number, status: number) {
        var url = this.endpoint + "/setBookingStatus"

        let body = {
            bid: bid,
            status: status
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async sendMessage(senderUid: string, receiverUid: string, receiverName: string, text: string, attachment: string) {
        var url = this.endpoint + "/sendMessage"

        let body = {
            senderUid: senderUid,
            receiverName: receiverName,
            receiverUid: receiverUid,
            text: text,
            attachment: attachment
        }

        console.log("calling: " + url)
        let p: Promise<BasicResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: BasicResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getConversation(senderUid: string, receiverUid: string) {
        var url = this.endpoint + "/conversation/" + senderUid + "/" + receiverUid

        console.log("calling: " + url)
        let p: Promise<ConversationResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ConversationResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    console.log(data.message)
                    reject(data.message)
                }
            })
        })

        return p
    }

    async getAdminConversation(uid: string, limit: number) {

        var url = this.endpoint + "/getAdminConversations/" + uid + "/" + limit

        console.log("calling: " + url)
        let p: Promise<ConversationResponse> = new Promise((resolve, reject) => {
            this.http.get(url, this.httpOptions).toPromise().then((data: ConversationResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data.message)
                }
            })
        })

        return p
    }

    async searchUser(text: string) {
        var url = "https://api.aitempo.online/searchUser"

        let body = {
            text: text
        }

        console.log("calling: " + url)
        let p: Promise<SearchResponse> = new Promise((resolve, reject) => {
            this.http.post(url, body, this.httpOptions).toPromise().then((data: SearchResponse) => {
                if (data) {
                    resolve(data)
                } else {
                    reject(data)
                }
            })
        })

        return p
    }


    async getPlaces(lat: number, lng: number, types: string[], radius: number) {
        const url = "https://api.aitempo.online/getPlaces"
        const body = {
            lat: lat,
            lng: lng,
            types: types,
            radius: radius
        }
        return firstValueFrom(this.http.post<PlacesResponse>(url, body, this.httpOptions))
    }

    province = {
        'AG': 'Agrigento',
        'AL': 'Alessandria',
        'AN': 'Ancona',
        'AO': 'Aosta',
        'AR': 'Arezzo',
        'AP': 'Ascoli Piceno',
        'AT': 'Asti',
        'AV': 'Avellino',
        'BA': 'Bari',
        'BT': 'Barletta-Andria-Trani',
        'BL': 'Belluno',
        'BN': 'Benevento',
        'BG': 'Bergamo',
        'BI': 'Biella',
        'BO': 'Bologna',
        'BZ': 'Bolzano',
        'BS': 'Brescia',
        'BR': 'Brindisi',
        'CA': 'Cagliari',
        'CL': 'Caltanissetta',
        'CB': 'Campobasso',
        'CI': 'Carbonia-Iglesias',
        'CE': 'Caserta',
        'CT': 'Catania',
        'CZ': 'Catanzaro',
        'CH': 'Chieti',
        'CO': 'Como',
        'CS': 'Cosenza',
        'CR': 'Cremona',
        'KR': 'Crotone',
        'CN': 'Cuneo',
        'EN': 'Enna',
        'FM': 'Fermo',
        'FE': 'Ferrara',
        'FI': 'Firenze',
        'FG': 'Foggia',
        'FC': 'Forlì-Cesena',
        'FR': 'Frosinone',
        'GE': 'Genova',
        'GO': 'Gorizia',
        'GR': 'Grosseto',
        'IM': 'Imperia',
        'IS': 'Isernia',
        'SP': 'La Spezia',
        'AQ': 'L\'Aquila',
        'LT': 'Latina',
        'LE': 'Lecce',
        'LC': 'Lecco',
        'LI': 'Livorno',
        'LO': 'Lodi',
        'LU': 'Lucca',
        'MC': 'Macerata',
        'MN': 'Mantova',
        'MS': 'Massa-Carrara',
        'MT': 'Matera',
        'ME': 'Messina',
        'MI': 'Milano',
        'MO': 'Modena',
        'MB': 'Monza e della Brianza',
        'NA': 'Napoli',
        'NO': 'Novara',
        'NU': 'Nuoro',
        'OT': 'Olbia-Tempio',
        'OR': 'Oristano',
        'PD': 'Padova',
        'PA': 'Palermo',
        'PR': 'Parma',
        'PV': 'Pavia',
        'PG': 'Perugia',
        'PU': 'Pesaro e Urbino',
        'PE': 'Pescara',
        'PC': 'Piacenza',
        'PI': 'Pisa',
        'PT': 'Pistoia',
        'PN': 'Pordenone',
        'PZ': 'Potenza',
        'PO': 'Prato',
        'RG': 'Ragusa',
        'RA': 'Ravenna',
        'RC': 'Reggio Calabria',
        'RE': 'Reggio Emilia',
        'RI': 'Rieti',
        'RN': 'Rimini',
        'RM': 'Roma',
        'RO': 'Rovigo',
        'SA': 'Salerno',
        'VS': 'Medio Campidano',
        'SS': 'Sassari',
        'SV': 'Savona',
        'SI': 'Siena',
        'SR': 'Siracusa',
        'SO': 'Sondrio',
        'TA': 'Taranto',
        'TE': 'Teramo',
        'TR': 'Terni',
        'TO': 'Torino',
        'OG': 'Ogliastra',
        'TP': 'Trapani',
        'TN': 'Trento',
        'TV': 'Treviso',
        'TS': 'Trieste',
        'UD': 'Udine',
        'VA': 'Varese',
        'VE': 'Venezia',
        'VB': 'Verbano-Cusio-Ossola',
        'VC': 'Vercelli',
        'VR': 'Verona',
        'VV': 'Vibo Valentia',
        'VI': 'Vicenza',
        'VT': 'Viterbo',
    }

    static stringify(obj: any) {
        return JSON.stringify(obj, null, 2)
    }

    getAllProvince() {

        var list = []
        for (const key of Object.keys(this.province)) {
            //for (const [key, value] of Object.entries(this.province)) {
            list.push({
                key: key,
                val: this.province[key]
            })
        }
        console.log(list.slice(0, 3))
        return list
    }

    getProvinceName(key: string) {
        if (this.province[key]) {
            return this.province[key]
        }
        return null
    }

    getYoutubeThumb(url: string) {
        let vid = url.split("?")[1].split("=")[1]
        let furl = "https://i3.ytimg.com/vi/" + vid + "/hqdefault.jpg"
        return furl
    }

    isiOS() {
        return Capacitor.getPlatform() == "ios" || Capacitor.getPlatform() == "web"
    }

    async presentToast(message: string, delay: number, icon: string, impact = false) {
        const toast = await this.toastController.create({
            duration: 5000,
            message: message,
            icon: icon
        })

        if (delay > 0) {
            setTimeout(() => {
                toast.present()
                if (impact) {
                    Haptics.impact({ style: ImpactStyle.Light })
                }
            }, delay);
        } else {
            toast.present()
            if (impact) {
                Haptics.impact({ style: ImpactStyle.Light })
            }
        }
    }

    async presentAlert(title: string, message: string) {
        const alert = await this.alertController.create({
            header: title,
            message: message,
            buttons: ["OK"]
        })
        alert.present()
        return alert
    }

    getBookingStatusColor(b: Service) {
        if (b.status == 1) {
            return "warning"
        }
        else if (b.status == 2) {
            return "primary"
        }
        else if (b.status == 3) {
            return "success"
        }

    }

    getBookingStatusText(b: Service) {
        if (b.status == 1) {
            return "prenotato"
        }
        else if (b.status == 2) {
            return "spedito"
        }
        else if (b.status == 3) {
            return "completato"
        }
    }

    getTrackingLabelText(b: Service) {
        if (b.shipping == 1) {
            return "Tracking della spedizione"
        } else {
            return "Link al servizio"
        }
    }

    openExternalLink(url: string) {
        window.open(url, "_system")
    }
}
